import { FileDownloadService } from "@topline/services/fileDownloadService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import moment from "moment";
import { ToasterService } from "@topline/services/toasterService";

(function (module) {
    "use strict";

    module.component("historicalData", {
        template: require("./historicalDataComponent.html"),
        bindings: {
            historicalStart: "<",
            historicalEnd: "<",
            inputArray: "<",
            valueType: "<",
            showInMilions: "="
        },
        controller: [
            "$scope",
            "PPGChartAndTableService",
            ToasterService.componentName,
            FileDownloadService.componentName,
            angularServicesNames.$translate,
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                PPGChartAndTableService: $TSFixMe,
                toasterService: ToasterService,
                fileDownloadService: FileDownloadService,
                $translate: ng.translate.ITranslateService
            ) {
                var $ctrl = this;

                $ctrl.sumDataToTable = (arr: $TSFixMe) => {
                    return PPGChartAndTableService.sumArrayItems(arr);
                };

                $ctrl.exportTable = function () {
                    const exportRows = _.map($ctrl.data, (x: $TSFixMe) => {
                        let value;
                        if ($ctrl.valueType === "mkshr") {
                            value = _.map(x.monthlyValues.slice(), (i: $TSFixMe) => i * 100);
                        } else {
                            value = x.monthlyValues;
                        }

                        return {
                            header: x.year,
                            isPercentage: $ctrl.valueType === "mkshr",
                            decimalPlaces: $ctrl.valueType === "mkshr" ? 2 : 0,
                            values: value
                        };
                    });

                    toasterService.showReportGenerateBusyIndicator(
                        () =>
                            fileDownloadService.exportTable("table.xlsx", {
                                columns: [
                                    $translate.instant("DTP_TABLE.MONTH.JANUARY"),
                                    $translate.instant("DTP_TABLE.MONTH.FEBRUARY"),
                                    $translate.instant("DTP_TABLE.MONTH.MARCH"),
                                    $translate.instant("DTP_TABLE.MONTH.APRIL"),
                                    $translate.instant("DTP_TABLE.MONTH.MAY"),
                                    $translate.instant("DTP_TABLE.MONTH.JUNE"),
                                    $translate.instant("DTP_TABLE.MONTH.JULY"),
                                    $translate.instant("DTP_TABLE.MONTH.AUGUST"),
                                    $translate.instant("DTP_TABLE.MONTH.SEPTEMBER"),
                                    $translate.instant("DTP_TABLE.MONTH.OCTOBER"),
                                    $translate.instant("DTP_TABLE.MONTH.NOVEMBER"),
                                    $translate.instant("DTP_TABLE.MONTH.DECEMBER")
                                ],
                                rows: exportRows
                            }),
                        "EXCEL_EXPORT_GENERATING",
                        "EXCEL_EXPORT_GENERATED"
                    );
                };

                $ctrl.isUndefinedOrNull = (x: $TSFixMe) => angular.isUndefinedOrNull(x);

                $ctrl.$onInit = function () {
                    $scope.$watchGroup(["$ctrl.inputArray"], function () {
                        if (!$ctrl.inputArray) return;
                        var data = [];
                        var startIndex = new Date($ctrl.historicalStart).getMonth();

                        var startMonth = moment($ctrl.historicalStart);
                        var i = 0;

                        if (startIndex > 0) {
                            var array = [];
                            for (var j = 0; j < 12; j++) {
                                i = j - startIndex;
                                array.push(i < 0 ? null : $ctrl.inputArray[i]);
                            }
                            data.push({
                                monthlyValues: array,
                                year: startMonth.format("YYYY")
                            });
                            startMonth.add(12 - startIndex, "months");
                            ++i;
                        }

                        for (; i < $ctrl.inputArray.length; i += 12) {
                            // @ts-expect-error ts-migrate(2403) FIXME: Subsequent variable declarations must have the sam... Remove this comment to see the full error message
                            var array = $ctrl.inputArray.slice(i, i + 12);
                            while (array.length < 12) {
                                array.push(null);
                            }
                            data.push({
                                monthlyValues: array,
                                year: startMonth.format("YYYY")
                            });
                            startMonth.add(12, "months");
                        }

                        $ctrl.data = data;
                    });
                };
            }
        ]
    });
})(angular.module("topline.modules"));
